import { useEffect } from "react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useAuthGate } from "@/hooks/use-auth-gate"
import { Skeleton } from "@/components/ui/skeleton"
import { EmployerHome } from "@/components/recruit/employer-home"
import { RecruitLandingPage } from "@/components/recruit/recruit-landing-page"
import { EmployerWorkspaceBoundary } from "@/features/company"

export const Route = createFileRoute("/recruit/")({
  component: RecruitIndexPage,
})

function RecruitIndexPage() {
  const gate = useAuthGate()
  const navigate = useNavigate()

  useEffect(() => {
    if (gate.status === "no-profile") {
      void navigate({ to: "/onboarding/role", search: { returnTo: "/recruit" } })
    }
  }, [gate, navigate])

  if (gate.status === "loading" || gate.status === "no-profile") {
    return (
      <div className="mkt-page home-wf">
        <div className="mkt-page-shell">
          <Skeleton className="h-32 w-full" />
        </div>
      </div>
    )
  }

  if (gate.status === "ready" && gate.profile.role === "employer") {
    return (
      <div className="mkt-page home-wf">
        <div className="mkt-page-shell">
          <EmployerWorkspaceBoundary>
            <EmployerHome />
          </EmployerWorkspaceBoundary>
        </div>
      </div>
    )
  }

  return <RecruitLandingPage />
}
